import React, { useState, useCallback } from 'react'
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Button } from '@material-ui/core'
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon
} from '@material-ui/icons'
import classNames from 'classnames'
// styles
import useStyles from './styles'

// components
import { Typography } from '../Wrappers/Wrappers'

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
} from '../../../context/LayoutContext'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormattedMessage } from 'react-intl'
import { useKeycloak } from '@react-keycloak/web'
import { NamedRoutes } from '../../../routes'
import { NavLink } from 'react-router-dom'
import LanguageSwitcher from '../../LanguageSwitcher'
import { md } from '../../../utils/ResponsiveUtility'

export default function ThemeHeader (props) {
  const classes = useStyles()

  // global
  const layoutState = useLayoutState()
  const layoutDispatch = useLayoutDispatch()

  const { keycloak } = useKeycloak()
  const { locale } = props
  const accountManagement = useCallback(() => {
      let newUrl = keycloak?.createAccountUrl() + '&kc_locale=' + locale
      window.location.href = newUrl
    }
    , [keycloak, locale])

  // local
  const [profileMenu, setProfileMenu] = useState(null)

  const [width, setWidth] = React.useState(document.body.clientWidth)
  let Mobile = (width < md)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse
          )}
        >
          {layoutState.isSidebarOpened ? (
            locale === 'ar' ?
              <ArrowForwardIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse
                  )
                }}
              /> :
              <ArrowBackIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse
                  )
                }}
              />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                )
              }}
            />
          )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype}>
          <AuthenticatedUserConsumer>
            {({ adminSectionType }) => (
              <FormattedMessage id={`Admin.Portal.Title.${adminSectionType || 'default'}`}/>
            )}
          </AuthenticatedUserConsumer>
        </Typography>
        <div className={classes.grow}/>
        {Mobile &&
        <LanguageSwitcher isMobile/>
        }
        <AuthenticatedUserConsumer>
          {({ userData, adminSectionType }) => (
            <>
              <IconButton
                aria-haspopup="true"
                color="inherit"
                className={classes.headerMenuButton}
                aria-controls="profile-menu"
                onClick={e => setProfileMenu(e.currentTarget)}
              >
                <AccountIcon classes={{ root: classes.headerIcon }}/>
              </IconButton>
              <Menu
                id="profile-menu"
                open={Boolean(profileMenu)}
                anchorEl={profileMenu}
                onClose={() => setProfileMenu(null)}
                className={classes.headerMenu}
                classes={{ paper: classes.profileMenu }}
                disableAutoFocusItem
              >
                <div className={classes.profileMenuUser}>
                  <Typography variant="h4" weight="medium">
                    {(!!Object.keys(userData).length) ?
                      <>
                        {(!!userData.first_name && userData.last_name) ? userData.first_name + ' ' + userData.last_name : (!!userData.username && userData.username)}
                        {!!userData.name && userData.name}
                      </>
                      : <FormattedMessage id='UserMenu.userName'/>}
                  </Typography>
                  {!!Object.keys(userData).length &&
                  <Typography
                    className={classes.profileMenuLink}
                    component="span"
                    color="primary"
                  >
                    {!!userData.username && userData.username}
                    {!!userData.preferred_username && userData.preferred_username}
                  </Typography>
                  }
                </div>
                {!!Object.keys(userData).length && !!userData.is_admin &&
                <MenuItem
                  className={classNames(
                    classes.profileMenuItem,
                    classes.headerMenuItem
                  )}
                  onClick={() => setProfileMenu(null)}
                >
                  <NavLink exact activeClassName="active" to={NamedRoutes.home}>
                    <HomeIcon className={classes.profileMenuIcon}/> <FormattedMessage id='UserMenu.home'/>
                  </NavLink>
                </MenuItem>
                }
                {!!Object.keys(userData).length && !!userData.is_admin &&
                <MenuItem
                  className={classNames(
                    classes.profileMenuItem,
                    classes.headerMenuItem
                  )}
                  onClick={() => setProfileMenu(null)}
                >
                  {/*{'subscription' === adminSectionType ?*/}
                  <Button onClick={accountManagement}>
                    <AccountIcon className={classes.profileMenuIcon}/> <FormattedMessage id='UserMenu.editProfile'/>
                  </Button>
                  {/*   : <NavLink exact activeClassName="active" to={NamedRoutes.editProfile}>*/}
                  {/*     <AccountIcon className={classes.profileMenuIcon}/> <FormattedMessage id='UserMenu.editProfile'/>*/}
                  {/*   </NavLink>*/}
                  {/* }*/}
                </MenuItem>
                }
                <div className={classes.profileMenuUser}>
                  <Typography
                    className={classes.profileMenuLink}
                    color="primary"
                    onClick={() => {
                      keycloak.logout()
                      setProfileMenu(null)
                    }}
                  >
                    <FormattedMessage id='UserMenu.logout'/>
                  </Typography>
                </div>
              </Menu>
            </>
          )}
        </AuthenticatedUserConsumer>
      </Toolbar>
    </AppBar>
  )
}
